// @ts-check
import { getColor } from 'common/constants/_colors';
import { StyledWidgetHeader } from 'components/base/common-styles';
import styled from 'styled-components';
import { SIZES } from 'common/constants/sizes';

export const StyledHeader = styled(StyledWidgetHeader)`
  margin-bottom: 0.5rem;
`;

export const StyledDescription = styled.div`
  color: ${getColor('shuttleGray')};
  font-size: ${SIZES.medium};
`;

export const StyledTypeViewWrapper = styled.div`
  margin-top: 2rem;
  min-height: 35rem;
`;

export const StyledMonteCarloSimulation = styled.div`
  margin-top: 3rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
